//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ProstateCancer_Gleason',
  data() {
    return {
      defaultJson:{
        "Major rank": "主要形态等级",
        "Minor order": "次要形态等级",
      },
      form:{
        majorRank:'',
        minorOrder:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"1",name:'由密集排列但相互分离的腺体构成境界清楚的肿瘤结节'},
        {value:"2",name:' 肿瘤结节有向周围正常组织的微浸润，且腺体排列疏松，异型性大于1(2)级'},
        {value:"3",name:'肿瘤性腺体大小不等，形态不规则，明显地浸润性生长，但每个腺体均独立不融合，有清楚的管腔'},
        {value:"4",name:'肿瘤性腺体相互融合，形成筛孔状，或细胞环形排列中间无腺腔形成'},
        {value:"5",name:'呈低分化癌表现，不形成明显的腺管，排列成实性细胞巢或单排及双排的细胞条索'},
      ],
      dataList2:[
        {value:"1",name:'由密集排列但相互分离的腺体构成境界清楚的肿瘤结节'},
        {value:"2",name:' 肿瘤结节有向周围正常组织的微浸润，且腺体排列疏松，异型性大于1(2)级'},
        {value:"3",name:'肿瘤性腺体大小不等，形态不规则，明显地浸润性生长，但每个腺体均独立不融合，有清楚的管腔'},
        {value:"4",name:'肿瘤性腺体相互融合，形成筛孔状，或细胞环形排列中间无腺腔形成'},
        {value:"5",name:'呈低分化癌表现，不形成明显的腺管，排列成实性细胞巢或单排及双排的细胞条索'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.majorRank + form.minorOrder;
        console.log(89, result)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/ProstateCancer_Gleason.vue